import dashboardSlice from './dashboardSlice'
export default dashboardSlice
